module.exports = __webpack_public_path__ + "media/promo/hochland/images/v2-e99de65328948a6844c7c4a361140287.png";